import { useTranslation } from 'react-i18next';

interface LanguageSwitcherProps {
  className?: string;
}

const LanguageSwitcher = ({ className = '' }: LanguageSwitcherProps) => {
  const { i18n } = useTranslation();
  const current_language = i18n.language?.startsWith('en') ? 'en' : 'fr';
  const next_language = current_language === 'en' ? 'fr' : 'en';

  const changeLanguage = () => {
    i18n.changeLanguage(next_language);
    document.documentElement.lang = next_language;
  };

  const aria_label = current_language === 'en' ? 'Switch to French' : "Passer à l'anglais";

  return (
    <button
      type="button"
      onClick={changeLanguage}
      className={`font-ambit text-[0.9375rem] font-bold leading-5 text-secondary transition-colors hover:text-primary ${className}`}
      aria-label={aria_label}
    >
      {current_language.toUpperCase()}
    </button>
  );
};

export default LanguageSwitcher;
